import { QueryError } from '@graphql-box/helpers';

import { useQuery } from '@graphql-box/react';
import { type Review as ReviewType } from '@tmdb-graphql-api/schema/types';
import { useEffect, useState } from 'react';
import { Ancestor } from '#enums/ancestors.ts';
import { useToolbelt } from '#hooks/useToolbelt.ts';
import { Review } from '../Review/index.tsx';
import { formatReview } from '../ReviewsDrawer/helpers/formatReviews.ts';
import { SlideoutDrawer } from '../SlideoutDrawer/index.tsx';
import { ReviewContainer } from './styled.ts';
import { type Props } from './types.ts';

const GET_REVIEW = "query GetReview($id: ID!) {\n  review(id: $id) {\n    author\n    authorDetails {\n      username\n      avatarPath\n      rating\n    }\n    content\n    createdAt\n    mediaTitle\n  }\n}\n";

export const ReviewDrawer = ({ id, setActiveReviewDrawer }: Props) => {
  const [open, setOpen] = useState<boolean>(true);
  const { config } = useToolbelt();

  useEffect(() => {
    if (!open) {
      setTimeout(() => {
        setActiveReviewDrawer(undefined);
      }, 310);
    }
  }, [open, setActiveReviewDrawer]);

  const { execute, loading, result } = useQuery<{ review: ReviewType }>(GET_REVIEW, {
    loading: true,
  });

  useEffect(() => {
    void execute({ variables: { id } }, { data: { initiator: 'ReviewDrawer' } });
    // We only want to re-execute when id changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (result instanceof QueryError) {
    console.error(result);
    return;
  }

  if (result?.errors?.length) {
    console.error(result.errors);
  }

  const hasReviewData = (reviewData: ReviewType | undefined): reviewData is ReviewType => !loading && !!reviewData;
  let title = '';

  if (hasReviewData(result?.data.review)) {
    title += result.data.review.author;
  }

  if (result?.data.review.mediaTitle) {
    title += ` on ${result.data.review.mediaTitle}`;
  }

  return (
    <SlideoutDrawer ancestor={Ancestor.ReviewsDrawer} loading={loading} open={open} setOpen={setOpen} title={title}>
      {hasReviewData(result?.data.review) ? (
        <ReviewContainer>
          <Review {...formatReview({ ...result.data.review }, config)} />
        </ReviewContainer>
      ) : undefined}
    </SlideoutDrawer>
  );
};
